import { SET_GAMES_DATA } from 'js/store/games/Games.actions.js';

import { parseData } from 'js/store/games/Games.parser.js';

const initState = {
  gameIds: [],
  gamesById: {},
};

const games = (state = initState, action) => {
  let nextState = {};

  switch (action.type) {
    case SET_GAMES_DATA: {
      const { gamesById, gameIds } = parseData(action.payload);
      nextState.gameIds = gameIds;
      nextState.gamesById = gamesById;
      return { ...state, ...nextState };
    }
  }
  return state;
};

export default games;
